<template>
    <div>
        <div v-for="(category) in categories">
            <div class="custom-categories-table-row custom-data-row">
<!--                <div class="custom-categories-table-label">-->
<!--                    <span>{{category.id}}</span>-->
<!--                </div>-->
                <div class="custom-categories-table-label">{{category.name}}</div>
                <!--                <div class="custom-categories-table-label">-->
                <!--                    <img class="ap-table-img" :src="urlForStatic('/img/tmp/siding.svg')"/>-->
                <!--                </div>-->
                <div class="custom-categories-table-label">
                    <div class="buttons-group-collection field-edit">
                        <div class="table-svg-button" v-on:click="addCategory(category.id, getHierarchy(category.id))">
                            <SVGPlus :width="20" :height="20"/>
                        </div>
                        <div class="table-svg-button" v-on:click="editCategory(category, getHierarchy(category.id))">
                            <SVGAdminEditRow/>
                        </div>
                        <div class="table-svg-button" v-on:click="confirm(category)">
                            <SVGAdminDeleteRow/>
                        </div>
                    </div>
                </div>
            </div>
            <AdminCategoriesRecursive style="margin-left: 15px; border-left: 2px solid #c5c5c5;" :parents="getHierarchy(category.id)" :categories="category.subcategories"/>
        </div>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow";
    import {urlForStaticVue} from "../../common";
    import ChangeCategory from "../../Modal/AdminPage/CategoriesPage/ChangeCategory";
    import SVGPlus from "../../SVG/SVGPlus";
    import AddCategory from "../../Modal/AdminPage/CategoriesPage/AddCategory";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminCategoriesRecursive",
        mixins: [urlForStaticVue],
        components: {
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            SVGPlus
        },
        props: {
            'categories': {
                type: Object
            },
            'parents': {
                type: Array,
                default(){
                    return [];
                }
            }
        },
        methods: {
            getHierarchy(id){
                return this.parents.concat([id]);
            },
            editCategory(dataCategory, hierarchyIds) {
                const parentHierarchyIds = Array.isArray(hierarchyIds) ? hierarchyIds.slice(0, hierarchyIds.length - 1) : [];
                this.$modal.show(ChangeCategory, {dataCategory, parentHierarchyIds}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            },
            addCategory(idSelectedCategory, hierarchyIds) {
                const parentHierarchyIds = Array.isArray(hierarchyIds) ? hierarchyIds : [];
                this.$modal.show(AddCategory, {idSelectedCategory, parentHierarchyIds}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            },
            deleteRow(categoryID) {
                return () => {this.$store.dispatch('adminPanel/categories/DELETE_CATEGORY', categoryID)};
            },
            confirm(category) {
                const title = `Удалить категорию "${category.name}"?`
                const text = 'Запись о данной категории будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(category.id)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
        }
    }
</script>

<style scoped>
.buttons-group-collection{
    display: grid;
    grid-template-columns: auto auto auto;
}
</style>
